import { navContentStore } from "@phn/state/nav-content-store";
import { h } from "@stencil/core";
import { dealerSearchResultsStore } from "@phn/state/dealer-search-results-store";
import {
  ClickElementTypes,
  DEALER_SEARCH_DISPLAY_ELEMENT_ID,
  ElementTypes,
  EventActions,
  GEOLOCATION_BUTTON_SEARCH_TERM,
} from "@phn/utility/constants";
import { isString } from "@phn/utility/helper";
import { GlobalDataLayerService } from "../../../../shared/services/analytics/global-data-layer-service";
import analyticsManager from "../../../../shared/services/analytics/analytics-manager";
import { RoutingKeys } from "../../../../shared/entities/routing-key";

export function DealerSearchMapLink() {
  const { dealer: dealerContent } = navContentStore.state;

  function emitDealersMapEvent() {
    const { map } = dealerContent.search;
    const { results, searchTerm } = dealerSearchResultsStore.state;

    GlobalDataLayerService.getInstance().pushDataLayerEvent(
      EventActions.DEALER_MAP_CLICK,
      {
        componentClick: {
          clickElementId: map.id,
          clickElementName: map.text,
          clickElementType: ClickElementTypes.Link,
          targetUrl: map.link,
        },
        componentDisplay: {
          displayElementId: DEALER_SEARCH_DISPLAY_ELEMENT_ID,
          displayElementType: analyticsManager.calculateDisplayElementType(
            RoutingKeys.DEALER_SEARCH,
            ElementTypes.dealerSearchForm,
          ),
          displayElementName: dealerContent.text,
        },
        componentSearch: {
          searchTerm: isString(searchTerm)
            ? searchTerm
            : GEOLOCATION_BUTTON_SEARCH_TERM,
          numberOfResults: results?.length,
        },
      },
    );
  }

  return (
    <a
      data-test-id="map-link"
      class={"map-link"}
      href={dealerContent.search.map.link}
      aria-label={dealerContent.search.map.description}
      onClick={emitDealersMapEvent}
    >
      {dealerContent.search.map.text}
      <phn-p-icon name="arrow-right" />
    </a>
  );
}
